"use client";
import { jsxs as b, jsx as s } from "react/jsx-runtime";
import { focusOutline as u } from "../../common/styles/mixins/focusOutline.js";
import { css as e } from "@emotion/react";
import c from "@emotion/styled";
import { opacity as t } from "../../helpers/color/color.js";
import { COLORS as o } from "../../tokens/colors/Colors.js";
import { MOTION_DURATIONS as d } from "../../tokens/motion-durations/MotionDurations.js";
import { MOTION_EASINGS as l } from "../../tokens/motion-easings/MotionEasings.js";
import { SIZES as i } from "../../tokens/sizes/Sizes.js";
import { forwardRef as f } from "react";
const $ = f(
  ({ className: r, feSize: p = "md", onChange: a, ...h }, m) => /* @__PURE__ */ b(k, { className: r, feSize: p, children: [
    /* @__PURE__ */ s(
      g,
      {
        ...h,
        onChange: (n) => a && a(n, n.target.checked),
        role: "switch",
        type: "checkbox",
        ref: m
      }
    ),
    /* @__PURE__ */ s(S, {})
  ] })
);
$.displayName = "SwitchControl";
const k = c.div(
  ({ feSize: r }) => e`
		display: inline-block;
		position: relative;

		${r === "md" && e`
			height: ${i.s24};
			width: ${i.s40};
		`}

		${r === "sm" && e`
			height: ${i.s20};
			width: ${i.s32};
		`}
	`
), g = c.input`
	cursor: pointer;
	height: inherit;
	inset: 0;
	margin: 0;
	opacity: 0;
	position: absolute;
	width: inherit;
	z-index: 1;

	&:disabled {
		cursor: not-allowed;
	}
`, S = c.div`
	background-color: ${o.gray400};
	border: 1px solid ${t(o.black, 0.1)};
	border-radius: 9999px;
	height: inherit;
	transition: background ${d.fast}ms ${l.easeIn};
	width: inherit;

	/* Handle */
	&::after {
		aspect-ratio: 1;
		background: ${o.white} content-box;
		border: 1px solid ${t(o.black, 0.1)};
		border-radius: 50%;
		content: '';
		display: block;
		height: 100%;
		transition: transform ${d.fast}ms ${l.easeIn};
	}

	input:checked ~ & {
		background-color: ${o.brand};
		border-color: transparent;

		&::after {
			transform: translateX(calc(100% - 6px));
		}
	}

	input:focus-visible ~ & {
		${u()}
	}

	input:disabled:not(:checked) ~ & {
		background-color: ${o.gray100};
		border-color: ${t(o.black, 0.05)};

		&::after {
			border-color: ${t(o.black, 0.05)};
		}
	}

	input:checked:disabled ~ & {
		background-color: ${o.blueBase};
	}
`;
export {
  $ as default
};
